import { markerContent } from './components/markerContent'
import './search'

let map,
    bounds,
    largePin,
    pin,
    infowindow = new google.maps.InfoWindow()

// Initialize map.
export function initMap(allMarkers) {
    // Create gerenic map.
    const mapArgs = {
        zoom: 8,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
    }

    map = new google.maps.Map(document.getElementById('map'), mapArgs)

    // Add markers.
    map.markers = []
    allMarkers.map((marker) => {
        initMarker(marker)
    })

    // Center map based on markers.
    centerMap(map)
    // Return map instance.
    return map
}

// Initialize markers.
export function initMarker(marker) {
    const content = marker

    // Get position from marker.
    var lat = marker.lat
    var lng = marker.lng
    var id = marker.id
    pin = {
        url: `${tlGlobal.templateDirectory}/src/assets/icons/map-pin.svg`,
        scaledSize: new google.maps.Size(27, 44),
    }

    largePin = {
        url: `${tlGlobal.templateDirectory}/src/assets/icons/map-pin.svg`,
        scaledSize: new google.maps.Size(36, 56),
    }

    var latLng = {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
    }

    // Create marker instance.
    marker = new google.maps.Marker({
        position: latLng,
        map,
        id,
        icon: pin,
        optimized: false,
    })

    // Append to reference for later use.
    map.markers.push(marker)

    marker.addListener('click', () => {
        infowindow.close()

        infowindow.setOptions({
            content: markerContent(content),
        })

        infowindow.open(map, marker)
    })
}

// Center map based on markers.
function centerMap(map) {
    // Create map boundaries from all map markers.
    bounds = new google.maps.LatLngBounds()
    map.markers.forEach((marker) => {
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng(),
        })
    })

    // Case: Single marker.
    if (map.markers.length == 1) {
        map.setCenter(bounds.getCenter())
        map.setZoom(12)

        // Case: Multiple markers.
    } else {
        map.fitBounds(bounds)
    }
}

// Re-center map when markers change.
export function updateMap(allMarkers) {
    map.markers.map((marker) => {
        marker.setMap(null)
    })
    map.markers = []
    allMarkers.map((marker) => {
        initMarker(marker)
    })

    centerMap(map)
}

// Highlight marker when list item is hovered.
document.addEventListener('mouseover', (e) => {
    if (e.target.closest('.map-search-item')) {
        const id = e.target.closest('.map-search-item').getAttribute('data-id')
        const marker = map.markers.find((marker) => marker.id === parseInt(id))
        marker.setZIndex(100)
        marker.setIcon(largePin)
    }
})

// Remove highlight when list item isn't hovered.
document.addEventListener('mouseout', (e) => {
    if (e.target.closest('.map-search-item')) {
        const id = e.target.closest('.map-search-item').getAttribute('data-id')
        const marker = map.markers.find((marker) => marker.id === parseInt(id))
        marker.setZIndex(0)
        marker.setIcon(pin)
    }
})

// open info window when list item is clicked.
document.addEventListener('click', (e) => {
    if (e.target.closest('.map-search-item')) {
        const id = e.target.closest('.map-search-item').getAttribute('data-id')
        const marker = map.markers.find((marker) => marker.id === parseInt(id))
        google.maps.event.trigger(marker, 'click')
    }
})
